<div class="content">
  <automata-automation-replacement-chips
    label="AUTOMATIONS.EDITOR.TRIGGERS.OPPORTUNITY.STATUS"
    [dataService]="opportunityStatusDataService"
    [formControl]="opportunityStatusControl"
    [supportDataPassing]="false"
    [isRequired]="true"
    [multiple]="false"
  >
  </automata-automation-replacement-chips>
  <!--Only show the closed reason field when status is closed-lost.-->
  <automata-automation-replacement-chips
    *ngIf="opportunityStatusControl.value === OpportunityStatus.ClosedLost"
    label="AUTOMATIONS.EDITOR.TRIGGERS.OPPORTUNITY.CLOSED_LOST_REASON"
    [dataService]="closedLostReasonDataService"
    [formControl]="closedLostReasonControl"
    [supportDataPassing]="false"
    [multiple]="false"
  ></automata-automation-replacement-chips>
</div>
